import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Home from "./components/Home";
import Sidebar from "./components/Sidebar";
import Courses from "./components/Courses";
import MyCourses from "./components/MyCourses";
import Videos from "./components/Videos";
import Pricing from "./components/payment/Pricing";
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import Blogs from "./components/Blogs";
import Contact from "./components/Contact";
import ForgetPassword from "./components/auth/ForgetPassword";
import AdminDashboard from "./components/admin/AdminDashboard";
// import AdminSidebar from "./components/admin/AdminSidebar";
import ResetPassword from "./components/auth/ResetPassword";
import PaymentSuccess from "./components/payment/PaymentSuccess";
import PaymentFail from "./components/payment/PaymentFail";
import PageNotFound from "./components/PageNotFound";
import Profile from "./components/Profile";
import { loadUserAction } from "./redux/actions/userAction";
import { ProtectedRoute } from "protected-route-react";
import CoursePage from "./components/course/CoursePage";
import CreateCourse from "./components/admin/CreateCourse";
import AllUsers from "./components/admin/AllUsers";
import AdminCoursePage from "./components/admin/AdminCoursePage";

// import Loader from "./components/Loader";
function App() {
  // window.addEventListener("contextmenu", (e) => {
  //   e.preventDefault()
  // })
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUserAction());
    // console.log(isAuthenticated)
  }, [dispatch]);
  return (
    <BrowserRouter>
      <>
        <Sidebar isAdmin={user && user.role} />
 
        <Routes>
          {/* Payment Routes  */}
          <Route path="/pricing" element={<Pricing user={user} />} />
          <Route path="/paymentsuccess/:ref" element={<PaymentSuccess />} />
          <Route path="/paymentfail" element={<PaymentFail />} />

          {/* 404 page  */}
          <Route path="*" element={<PageNotFound />} />

          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/course/:id" element={<CoursePage />} />

          <Route path="/mycourses" element={ 
                <MyCourses /> 

          // <ProtectedRoute
          //        isAuthenticated={!isAuthenticated}
          //        redirect="/profile"
          //     >
          //     </ProtectedRoute>
             } />
          <Route path="/videos" element={<Videos />} />
          <Route
            path="/login"
            element={
              <ProtectedRoute
                isAuthenticated={!isAuthenticated}
                redirect="/profile"
              >
                <Login />
              </ProtectedRoute>
            }
          />
          <Route
            path="/signup"
            element={
              <ProtectedRoute
                isAuthenticated={!isAuthenticated}
                redirect="/profile"
              >
                <Signup />
              </ProtectedRoute>
            }
          />
          <Route path="/forgetpassword" element={<ForgetPassword />} />
          <Route path="/resetpassword/:token" element={<ResetPassword />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Profile user={user} />
              </ProtectedRoute>
            }
          />

          {/* admin routes  */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                isAdmin={user && user.role}
                adminRoute={true}
                redirect="/"
              >
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/createcourse"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                isAdmin={user && user.role}
                adminRoute={true}
                redirect="/"
              >
                <CreateCourse />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                isAdmin={user && user.role}
                adminRoute={true}
                redirect="/"
              >
                <AllUsers />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/courses"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                isAdmin={user && user.role}
                adminRoute={true}
                redirect="/"
              >
                <AdminCoursePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/createcourse"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                isAdmin={user && user.role}
                adminRoute={true}
                redirect="/"
              >
                <CreateCourse />
              </ProtectedRoute>
            }
          />
        </Routes>
      </>
    </BrowserRouter>
  );
}

export default App;
